import {CONFIRMATION_PAGE_PATH, PAYMENT_PAGE_PATH} from 'utils/urls'

import {Page} from '@vio/core/src/analytics/types/Events'

interface ValidationError {
  field: string
  errorMsg: string
}
type FormValidationError = Record<string, string | Record<string, string>>
export interface ValidationErroredPayload {
  validationError: ValidationError[]
  bookingRequestId: string
}

export interface TrackEventMetadata {
  searchId: string | null
  currency: string
}

const EventSpace = {
  BOOKING_CONFIRMATION_PAGE: 'booking_confirmation_page',
  PAYMENT_PAGE: 'payment_page',
  CHECKOUT: 'checkout'
}

export const getPageSpace = (pathname: string) => {
  // eslint-disable-next-line default-case
  switch (pathname) {
    case PAYMENT_PAGE_PATH: {
      return EventSpace.PAYMENT_PAGE
    }

    case CONFIRMATION_PAGE_PATH: {
      return EventSpace.BOOKING_CONFIRMATION_PAGE
    }
  }
}

export const errorsToEventsPayload = (
  errors:
    | FormValidationError
    | FormValidationError[]
    | string
    | string[]
    | undefined,
  bookingRequestId: string
): ValidationErroredPayload => {
  if (!errors)
    return {
      validationError: [],
      bookingRequestId
    }

  const flattenedErrors = Array.isArray(errors)
    ? Object.entries(errors.flat().find(Boolean) ?? {})
    : Object.entries(errors)

  const validationError = flattenedErrors.map(
    ([key, value]): ValidationError => ({
      field: key,
      errorMsg: typeof value === 'object' ? JSON.stringify(value) : value
    })
  )

  const errorPayload = {
    validationError,
    bookingRequestId
  }
  return errorPayload
}

export const getPageName = (pathname: string) => {
  switch (pathname) {
    case PAYMENT_PAGE_PATH:
      return Page.Payment

    case CONFIRMATION_PAGE_PATH:
      return Page.Confirmation

    default:
      return null
  }
}
